import PostsPage from './PostsPage'
export default PostsPage